/**
 * Bank Account System Check Rule
 *
 * The evidence rule on which the system check gave a bank account's first signature (ADR D5).
 */
export const SystemCheckRule = {
  /** First reported by the ERP for this party, and never written out by Tappeer */
  E1: 'E1',
  /** An earlier payment to it was confirmed by a statement and not returned */
  E2: 'E2',
  /** Published in the CZ/SK VAT register for the party's VAT ID and IČO */
  E3: 'E3'
} as const;

export type SystemCheckRule = (typeof SystemCheckRule)[keyof typeof SystemCheckRule];
